import { useMemo } from 'react'
import { useForm } from 'react-hook-form'
import { userOptionsStore } from '~/shared/api'
import { localeEnumOptions, OptionEnum } from '~/shared/config/constants'
import { LocaleEnum } from '~/shared/config/enums'
import { DEFAULT_LOCALE, i18nModel } from '~/shared/lib/i18n'
import { DrawerSelect, FormProvider } from '~/shared/ui/form'

export function LocaleForm() {
  const defaultValues = useMemo(() => {
    const locale = userOptionsStore.locale || DEFAULT_LOCALE
    return {
      locale: localeEnumOptions.find(
        (localeOption) => localeOption.id === locale,
      ) as OptionEnum<LocaleEnum>,
    }
  }, [])

  const form = useForm<{ locale: OptionEnum<LocaleEnum> }>({
    defaultValues,
  })
  const { watch } = form

  const handleLocaleChange = (locale: OptionEnum<LocaleEnum>) => {
    form.setValue('locale', locale)
    i18nModel.localeChangeFx({ locale: locale.id })
  }

  watch((data, { name, type }) => {
    if (type !== 'change') return

    if (name === 'locale') {
      handleLocaleChange(data.locale as OptionEnum<LocaleEnum>)
    }
  })

  return (
    <FormProvider form={form}>
      <DrawerSelect
        name='locale'
        title='form.localization'
        label='form.localization'
        defaultOptions={localeEnumOptions}
      />
    </FormProvider>
  )
}
